module.exports = __webpack_public_path__ + "img/notification-message.617084e2.svg";